import { backUrl } from "../utils/backURL";
import { apiFetch } from "../utils/apiFetch";
import Cookies from "js-cookie";

export const createDocumentFormat = async (token, mantisBusinessId, formatData) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
      ...formatData,
    }),
  });
  const data = await res.json();
  return data;
};

export const getDocumentFormats = async (token, mantisBusinessId, includeDeleted = false) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/list`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify({
      mantisBusinessId,
      includeDeleted,
    }),
  });
  const data = await res.json();
  return data;
};

export const getDocumentFormatById = async (token, formatId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/${formatId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
  });
  const data = await res.json();
  return data;
};

export const updateDocumentFormat = async (token, formatId, formatData) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/${formatId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
    body: JSON.stringify(formatData),
  });
  const data = await res.json();
  return data;
};

export const softDeleteDocumentFormat = async (token, formatId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/${formatId}/soft-delete`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
  });
  const data = await res.json();
  return data;
};

export const hardDeleteDocumentFormat = async (token, formatId) => {
  const csrfToken = Cookies.get("csrfToken");
  const res = await apiFetch(`${backUrl}/documentFormats/${formatId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "X-CSRF-TOKEN": csrfToken,
    },
  });
  const data = await res.json();
  return data;
};
